import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";
import { DeniedState } from "../workflowOperations/components/SurfaceState";
import "../workflowOperations/workflowOperations.css";

const hasAbrAccess = (authUser) => authUser?.Claims?.includes("admin.access");

const Abr = ({ match }) => {
  const authUser = useSelector((state) => state.auth?.authUser || null);

  if (!hasAbrAccess(authUser)) {
    return (
      <div className="app-wrapper">
        <div className="workflow-ops-panel mt-3">
          <DeniedState reason="ABR is available to admin users only." />
        </div>
      </div>
    );
  }

  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/preview`} />
        <Redirect exact from={match.url} to={`${match.url}/preview`} />
        <Route
          exact
          path={`${match.url}/preview`}
          component={asyncComponent(() => import("./routes/PreviewPage"))}
        />
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default Abr;
